import * as React from "react";
import { List, ListItemButton, ListItemText, Typography } from "@mui/material";
import { TSetUrlParamsArgs } from "../../../../hooks/useXoraia";
import { useCategories } from "../../../../hooks/useCategories";

const CategoryFilter: React.FC<{
  showCount?: boolean; // TODO IMPLEMENT COUNT
  onChange: (args: TSetUrlParamsArgs) => Promise<void>;
  urlParams?: TSetUrlParamsArgs;
}> = ({ onChange, urlParams = {} }) => {
  const { categories } = useCategories();

  if (categories.length === 0) {
    return (
      <Typography color="GrayText">{"Il n'y a aucune catégorie"}</Typography>
    );
  }

  return (
    <List disablePadding>
      {categories.map((cat) => {
        return (
          <ListItemButton
            key={cat.id}
            disableGutters
            disableRipple
            selected={urlParams.c === cat.id}
            onClick={async () => {
              await onChange({ c: cat.id });
            }}
          >
            <ListItemText primary={cat.name} />
            {/* <ListItemText primary={`Category 1${showCount ? " (10)" : ""}`} /> */}
          </ListItemButton>
        );
      })}
    </List>
  );
};

export default CategoryFilter;
